import React from 'react';

// Component for external links that open in a new tab
const ExternalLink = ({ to, className, children, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(to, '_blank');
    if (onClick) onClick(e);
  };

  return (
    <a 
      href={to}
      className={className}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
